import React from 'react';

import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import { useWorkflowShowHref } from '@dashboard/hooks/route/hrefs';
import { Typography } from '@mui/material';

type Props = {
  workflowId: string;
};
export default function WorkflowLinkButton({ workflowId }: Props) {
  const workflowHref = useWorkflowShowHref({ id: workflowId });
  return (
    <ButtonLink size="small" color="secondary" href={workflowHref}>
      <Typography variant="body2" color="inherit" fontWeight="medium">
        Edit workflow
      </Typography>
    </ButtonLink>
  );
}
